import { UseFormReturn } from "react-hook-form";

export const validateForm = async (form: UseFormReturn<any>) => {
  const output = await form.trigger(undefined, { shouldFocus: true });
  return !!output;
};
